import React from 'react';
import '../../../styling/SpinnerStyle.css'


const LoadQualitySpinner = (props) => {

    const {
        loadAnalyticsSpinner
    } = props;

    return(
            <div
                style={loadAnalyticsSpinner === false ? { display: 'none' } : null}
                id="cover-spin-project"
            >
                <div style={{position: 'absolute', top:'35%', fontSize: '1.5vw', justifyContent: 'center', display: 'flex', width: '100%'}}> <span style={{color: '#0c4d82'}}>Please wait while loading project quality analytics.. </span></div>
            </div>
    )

}

export default LoadQualitySpinner;